module.exports = __webpack_public_path__ + "img/social.c2c5fa04.png";